import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { FactCheckResolution, LlmAction, SentenceIdPair } from './ai-action.types'

@Injectable({
  providedIn: 'root',
})
export class AiActionService {
  private httpClient = inject(HttpClient)

  sendStreamingRequest(
    meetingId: number,
    action: LlmAction,
    sentenceIdPairs: SentenceIdPair[],
    selectionContent: string,
    templateItemIds: number[],
    existingItemContent: string | null
  ): EventSource {
    const queryParams = new URLSearchParams({
      action,
      sentenceIdPairs: JSON.stringify(sentenceIdPairs),
      selectionContent,
      templateItemIds: JSON.stringify(templateItemIds),
      existingItemContent: existingItemContent ?? '',
    }).toString()

    return new EventSource(`/api/meetings/${meetingId}/llm-live-async?${queryParams}`, {
      withCredentials: true,
    })
  }

  sendSyncRequest(
    meetingId: number,
    action: LlmAction,
    sentenceIdPairs: SentenceIdPair[],
    selectionContent: string,
    templateItemIds: number[],
    existingItemContent: string | null
  ): Observable<FactCheckResolution[]> {
    return this.httpClient.post<FactCheckResolution[]>(`/api/meetings/${meetingId}/llm-live-sync`, {
      action,
      sentenceIdPairs,
      selectionContent,
      templateItemIds,
      existingItemContent,
    })
  }
}
